import { http } from 'services';

// Personal - View profile
export function getProfile(cbSuccess, cbError) {
  http.get(
    'personal/profile',
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Update profile
export function updateProfile(payload, cbSuccess, cbError) {
  http.patch(
    'personal/profile',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Get Life stages list
export function getLifeStages(cbSuccess, cbError) {
  http.get(
    'personal/life-stages',
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Get personal statistics
export function getStatistics(cbSuccess, cbError) {
  http.get(
    'personal/statistics',
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Personal - Deactivate account
export function deactivateAccount(payload, cbSuccess, cbError) {
  http.post(
    'personal/deactivate-account',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-personal/api-personal-profile.js